export const TABS_TABLE = {
	PRICING: 'pricing',
	MIN_MAX: 'minMax'
}

export const ORDER_WIDGET_BY = {
	PRICE: 'price',
	NAME: 'name'
}